import { reportCarburetion3Types } from "./types";
import { newDate } from "helpers/dateTools";

const {
  SET_CARBURETION3_FILTERS,
  RESTORE_INITIAL
} = reportCarburetion3Types;

const initialState = {
  startDate: newDate(),
  endDate: newDate(),
  station: null,
};

export const reportCarburetion3Reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_CARBURETION3_FILTERS:
      return { ...state, [payload.key]: payload.value };

    case RESTORE_INITIAL:
      return initialState;

    default:
      return state;
  }
};
